import { Fragment } from 'react'
import { useSnackbar } from 'notistack'

import CopyAllIcon from '@mui/icons-material/CopyAll'
import { Divider, IconButton, Stack, Typography } from '@mui/material'

export type DataCardDetailsEntry = {
  key: string
  value: string | number
  copyable?: boolean
}

type Props = {
  details: DataCardDetailsEntry[]
}

export const DataCardDetails = ({ details }: Props) => {
  const { enqueueSnackbar } = useSnackbar()

  const handleCopy = (value: string | number) => {
    navigator.clipboard.writeText(String(value))
    enqueueSnackbar('Copied to clipboard', { variant: 'success' })
  }

  return (
    <Stack
      pb={1}
      direction="row"
      spacing={2.5}
      mx={1}
      px={1.5}
      mb={1}
      pt={1}
      pl={2.5}
      sx={{
        borderRadius: 1.25,
        backgroundColor: ({ palette }) => (palette.mode === 'light' ? '#efefef' : '#333')
      }}
    >
      {details.map((entry, idx) => (
        <Fragment key={entry.key}>
          <Stack direction="column">
            <Typography variant="body2" color="text.secondary" fontSize={12}>
              {entry.key}
            </Typography>
            <Stack direction="row" alignItems="center">
              <Typography variant="body1" fontSize={12}>
                {entry.value}
              </Typography>
              {entry.copyable && (
                <IconButton
                  size="small"
                  onClick={() => handleCopy(entry.value)}
                  sx={{ my: -1, mr: -1 }}
                  data-testid={`copy-${entry.key}`}
                >
                  <CopyAllIcon fontSize="small" />
                </IconButton>
              )}
            </Stack>
          </Stack>
          {idx < details.length - 1 && <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />}
        </Fragment>
      ))}
    </Stack>
  )
}
